import React, { FC, useEffect, useState } from 'react';

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import CircularProgress from '@mui/material/CircularProgress';

import { GalleryItem } from 'components/MediaEditor';

type Props = {
  file: GalleryItem;
};

const MediaEditorPreviewThumb: FC<Props> = ({ file }) => {
  const [url, setUrl] = useState<string>('');

  useEffect(() => {
    const createdUrl = URL.createObjectURL(file.file);
    setUrl(createdUrl);

    return () => {
      URL.revokeObjectURL(createdUrl);
    };
  }, [file.file]);

  return (
    <Grid
      item
      xs={12}
      sm={6}
      md={4}
      lg={3}
      xl={2}
      sx={{
        mb: 2,
        position: 'relative',
      }}>
      <Box
        sx={{
          position: 'absolute',
          width: '100%',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#ffffff',
        }}>
        <CircularProgress color="inherit" variant="indeterminate" />
      </Box>

      <Box
        sx={{
          height: '100%',
          minHeight: '125px',
          '& img': {
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            borderRadius: theme => theme.shape.borderRadius,
          },
        }}>
        <img src={url} alt="" />
      </Box>
    </Grid>
  );
};

export default MediaEditorPreviewThumb;
